<template>
  <v-tabs @change="tabChange" class="h100p" v-model="activeTabIndex">
    <v-tab v-for="tab in tabs" :key="tab.name" class="f1-5">
      <bh-icon v-if="tab.icon" :icon="tab.icon" />
      <span class="mr-5">{{ tab.name }}</span>
      <bh-tooltip :tooltipContent="tab.tooltipContent" />
    </v-tab>
    <v-tabs-items class="pa1">
      <slot></slot>
    </v-tabs-items>
  </v-tabs>
</template>
<script>
export default {
  name: 'bh-tab',
  props: {
    tabs: {
      type: Array,
      default() {
        return [
          {
            name: 'Tab 1'
          },
          {
            name: 'Tab 2'
          }
        ]
      }
    },
    activeTab: Number
  },
  data() {
    return {
      activeTabIndex: this.activeTab
    }
  },
  methods: {
    tabChange(e) {
      this.$emit('tabChange', e)
    }
  }
}
</script>
